import React from "react";
import PropTypes from "prop-types";
import CompanySkeletonCard from "../card/company_skeleton_card";

function CompanySkeletonPage({ numberOfCards, singleRow = false }) {
  const hideClass = (index) => {
    if (!singleRow) return "";

    switch (index) {
      case 1:
        return `d-none ${numberOfCards === 4 ? "d-sm-block" : "d-md-block"}`;
      case 2:
        return `d-none ${numberOfCards === 4 ? "d-md-block" : "d-xl-block"}`;
      case 3:
        return "d-none d-xl-block";
      default:
        return "";
    }
  };

  return (
    <>
      {Array(numberOfCards)
        .fill()
        .map((item, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div className={hideClass(index)} key={index} style={{ gridRow: "span 3" }}>
            <CompanySkeletonCard />
          </div>
        ))}
    </>
  );
}

CompanySkeletonPage.propTypes = {
  numberOfCards: PropTypes.number.isRequired,
  singleRow: PropTypes.bool,
};

export default CompanySkeletonPage;
